import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEmphasis32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveEmphasis32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M27.173 4.419a1.2 1.2 0 0 1-1.2 1.2H6.049a1.2 1.2 0 0 1 0-2.4h19.924a1.2 1.2 0 0 1 1.2 1.2m0 23.14a1.2 1.2 0 0 1-1.2 1.2H6.049a1.2 1.2 0 0 1 0-2.4h19.924a1.2 1.2 0 0 1 1.2 1.2m-3.774-11.57a7.402 7.402 0 1 1-14.804-.001 7.402 7.402 0 0 1 14.804.001m-2.4 0a5.001 5.001 0 1 0-10.002 0 5.001 5.001 0 0 0 10.002 0"
            />
        </svg>
    );
}
export default memo(IconMoveEmphasis32);
